module.exports = __webpack_public_path__ + "img/facebook.872e7cb4.svg";